import {CounterLabel, Details, Heading, Spinner, useDetails} from '@primer/react'
import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PendingCommentPreview} from '../PendingCommentPreview'
import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import type {PendingComment} from '../../../page-data/payloads/thread-previews'

export function ReviewCommentsSection({
  totalPendingComments,
  commentsList,
  handleNavigateToDiffComment,
}: {
  totalPendingComments?: number
  commentsList?: PendingComment[]
  handleNavigateToDiffComment: () => void
}) {
  const {getDetailsProps, open} = useDetails({defaultOpen: true, closeOnOutsideClick: false})

  if (!totalPendingComments) return null

  return (
    <>
      <Details {...getDetailsProps()}>
        <Details.Summary>
          <div className="d-flex flex-row flex-items-center gap-2 tmp-mt-4 mb-2">
            {open && <ChevronDownIcon className="fgColor-muted" />}
            {!open && <ChevronRightIcon className="fgColor-muted" />}
            <Heading as="h2" className="f5">
              Pending comments <CounterLabel>{totalPendingComments}</CounterLabel>
            </Heading>
          </div>
        </Details.Summary>

        <ErrorBoundary
          boundaryName="ReviewCommentsSection"
          fallback={<span className="fgColor-muted">Unable to load pending comments</span>}
        >
          <Suspense fallback={<Spinner />}>
            <div className="d-flex flex-column gap-3">
              {commentsList?.map(pendingComment => (
                <PendingCommentPreview
                  key={pendingComment.commentID}
                  pendingComment={pendingComment}
                  onNavigateToDiffComment={handleNavigateToDiffComment}
                />
              ))}
            </div>
          </Suspense>
        </ErrorBoundary>
      </Details>
    </>
  )
}
